const YearlyBarsLinesChart = require('./YearlyBarsLinesChart');

module.exports = YearlyBarsLinesChart;
